import { i18n, Locale } from 'i18n-config';

export const getLocale = () => {
  const match = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
  return (
    match && i18n.locales.includes(match?.at(1) as Locale) ? match?.at(1) : i18n.defaultLocale
  ) as Locale;
};
